<div class="p-6">
  <a [routerLink]="eventId>0 ? ['/events', eventId] : '/events'" [queryParams]="{tab:'details'}" class="text-sm underline text-grey-700">&lt; Back to Event</a>
  <h1 class="text-2xl font-semibold mt-2 mb-4">Edit Question</h1>

  <div class="flex flex-col gap-4 page-stack">
    <div class="card question-summary">
      <div class="section-header">
        <div>
          <p class="label mb-1">Question</p>
          <p class="font-semibold leading-tight">{{question.QuestionHeader || 'Question'}}</p>
        </div>
        <span class="pill-highlight">{{question.QuestionResult || 'Not answered'}}</span>
      </div>
      <p class="text-sm text-grey-800 mt-2">{{question.QuestionBody}}</p>
    </div>

    <div class="card section-card">
      <div class="section-block mt-0" [ngClass]="{'editing-active': isEditing('answer')}">
        <div class="flex items-center justify-between">
          <p class="label">Answer</p>
          <div class="flex gap-2">
            @if (!isEditing('answer')) {
              <button type="button" class="btn-inverse btn-compact btn-small" (click)="startEdit('answer')" [disabled]="!canEdit('answer')" [ngClass]="{'disabled-edit': editingSection && !isEditing('answer')}">
                <i class="pi pi-pencil mr-1"></i>
                <span>Edit</span>
              </button>
            }
          </div>
        </div>

        @if (!isEditing('answer')) {
          <div class="mt-2">
            <p class="text-sm text-grey-900 font-semibold">{{question.QuestionResult || 'Not answered'}}</p>
            @if (question.NASelected) {
              <p class="text-xs text-grey-700 mt-1">Marked as N/A</p>
            }
          </div>
        }

        @if (isEditing('answer')) {
          @if (question.AllowNA) {
            <div class="flex items-center gap-2 text-sm mt-2">
              <p-toggleSwitch [(ngModel)]="naSelected"></p-toggleSwitch>
              <span>Mark as N/A</span>
            </div>
          }
          @if ((question.QuestionTypeID === 1 || question.QuestionTypeID === 2) && question.QuestionAnswers!.length > 0) {
            @if (question.QuestionTypeID === 1) {
              <div class="flex flex-col gap-2 mt-2">
                @for (answer of question.QuestionAnswers; track answer.QuestionAnswerID) {
                  <div class="flex items-center gap-2">
                    <p-radiobutton
                      [inputId]="'answer-' + question.QuestionID + '-' + answer.QuestionAnswerID"
                      name="answer-{{question.QuestionID}}"
                      [disabled]="naSelected"
                      [value]="answer.QuestionAnswerID"
                      [(ngModel)]="selectedAnswerId"
                      (onClick)="onSelectAnswer(answer.QuestionAnswerID)"
                    ></p-radiobutton>
                    <label class="cursor-pointer" [for]="'answer-' + question.QuestionID + '-' + answer.QuestionAnswerID">{{answer.AnswerText}}</label>
                  </div>
                }
              </div>
            }
            @if (question.QuestionTypeID === 2) {
              <p-select class="mt-2 w-full" [options]="question.QuestionAnswers" optionLabel="AnswerText" optionValue="QuestionAnswerID" [showClear]="true" placeholder="Please select..." [disabled]="naSelected" [(ngModel)]="selectedAnswerId" (onChange)="onSelectAnswer($event.value)"></p-select>
            }
          }

          @if ((question.QuestionTypeID === 1 || question.QuestionTypeID === 2) && (!question.QuestionAnswers || question.QuestionAnswers.length === 0)) {
            <p class="text-sm text-grey-700 mt-2">No answer options available for this question.</p>
          }

          @if (question.QuestionTypeID === 3 && question.QuestionAnswers!.length > 0) {
            <p-multiselect class="mt-2 w-full" [options]="question.QuestionAnswers" optionLabel="AnswerText" optionValue="QuestionAnswerID" display="chip" [disabled]="naSelected" [(ngModel)]="selectedAnswerIds" (onChange)="onMultiChange($event.value)"></p-multiselect>
          }
          @if (question.QuestionTypeID === 3 && (!question.QuestionAnswers || question.QuestionAnswers.length === 0)) {
            <p class="text-sm text-grey-700">No answer options available for this question.</p>
          }

          @if (question.QuestionTypeID === 9) {
            <p-datepicker class="mt-2 date-input" [showIcon]="false" dateFormat="dd M yy" [disabled]="naSelected" [(ngModel)]="dateValue" [panelStyle]="{minWidth: '14rem', width: 'auto'}"></p-datepicker>
          }
          @if (question.QuestionTypeID === 10) {
            <p-datepicker class="mt-2 date-input" [showIcon]="false" [showTime]="true" hourFormat="24" dateFormat="dd M yy" [disabled]="naSelected" [(ngModel)]="dateValue" [panelStyle]="{minWidth: '14rem', width: 'auto'}"></p-datepicker>
          }

          @if (question.QuestionTypeID === 4) {
            <input pInputText class="text-box w-full mt-2" type="text" [disabled]="naSelected" [(ngModel)]="newAnswer" placeholder="Enter answer"/>
          }
          @if (question.QuestionTypeID === 5 || question.QuestionTypeID === 11) {
            <textarea pTextarea class="text-box w-full mt-2" rows="5" [disabled]="naSelected" [(ngModel)]="newAnswer" placeholder="Enter answer"></textarea>
          }
          @if (question.QuestionTypeID === 8) {
            <p class="text-sm text-grey-700 mb-2">Signature/image questions should be updated in the original audit flow. Existing data will be retained.</p>
            <textarea pTextarea class="text-box w-full mt-2" rows="4" [disabled]="naSelected" [(ngModel)]="newAnswer"></textarea>
          }
          @if (question.QuestionTypeID !== 1 && question.QuestionTypeID !== 2 && question.QuestionTypeID !== 3 && question.QuestionTypeID !== 4 && question.QuestionTypeID !== 5 && question.QuestionTypeID !== 8 && question.QuestionTypeID !== 9 && question.QuestionTypeID !== 10 && question.QuestionTypeID !== 11) {
            <textarea pTextarea class="text-box w-full mt-2" rows="4" [disabled]="naSelected" [(ngModel)]="newAnswer"></textarea>
          }
          <div class="flex gap-2 mt-3">
            <button class="btn-primary btn-small" type="button" [disabled]="saving" (click)="saveAnswer()">
              <i class="pi" [ngClass]="saving ? 'pi-spin pi-spinner' : 'pi-save'"></i>
              <span class="ml-1">{{saving ? 'Saving...' : 'Save Answer'}}</span>
            </button>
            <button class="btn-inverse btn-small" type="button" (click)="cancelEdit('answer')">Cancel</button>
          </div>
        }
      </div>

      <div class="mt-4 section-block" [ngClass]="{'editing-active': isEditing('comments')}">
        <div class="flex items-center justify-between">
          <p class="label">Comments</p>
          <div class="flex gap-2">
            @if (!isEditing('comments')) {
              <button type="button" class="btn-inverse btn-compact btn-small" (click)="startEdit('comments')" [disabled]="!canEdit('comments')" [ngClass]="{'disabled-edit': editingSection && !isEditing('comments')}">
                <i class="pi pi-pencil mr-1"></i>
                <span>Edit</span>
              </button>
            }
          </div>
        </div>
        @if (!isEditing('comments')) {
          <p class="text-sm text-grey-900 mt-1">{{newComment || 'No comment added.'}}</p>
        }
        @if (isEditing('comments')) {
          <textarea pTextarea class="text-box w-full" rows="3" [(ngModel)]="newComment"></textarea>
          <div class="flex gap-2 mt-3">
            <button class="btn-primary btn-small" type="button" [disabled]="saving" (click)="saveComments()">
              <i class="pi" [ngClass]="saving ? 'pi-spin pi-spinner' : 'pi-save'"></i>
              <span class="ml-1">{{saving ? 'Saving...' : 'Save Comment'}}</span>
            </button>
            <button class="btn-inverse btn-small" type="button" (click)="cancelEdit('comments')">Cancel</button>
          </div>
        }
      </div>
      <div class="mt-4">
        <button type="button" class="accordion-trigger w-full flex items-center justify-between" (click)="toggleAttachments()" [ngClass]="{'expanded': attachmentsExpanded}">
          <div class="flex items-center gap-2">
            <i class="pi pi-paperclip text-grey-700"></i>
            <span class="label mb-0">Attachments</span>
          </div>
          <div class="flex items-center gap-2">
            <span class="count-pill">{{question.QuestionAttachments.length || 0}}</span>
            <i class="pi" [ngClass]="attachmentsExpanded ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
          </div>
        </button>
        @if (attachmentsExpanded) {
          <div class="accordion-body">
            @if (question.QuestionAttachments!.length > 0) {
              <div class="flex flex-col gap-2 mt-2">
                @for (att of question.QuestionAttachments; track att.AttachmentID) {
                  <div class="flex items-center justify-between border border-green-50 rounded px-2 py-1 bg-white gap-3">
                    <div class="flex items-center gap-2">
                      @if (isImageAttachment(att)) {
                        <img [src]="attachmentSrc(att.GUID)" alt="" class="attachment-thumb">
                      }
                      <div class="flex items-center gap-2">
                        <i class="pi pi-paperclip text-grey-700"></i>
                        <span class="underline cursor-pointer hover:text-green-700" (click)="downloadAttachment(att.GUID)">{{att.FileName}}</span>
                      </div>
                    </div>
                    <button class="btn-inverse btn-compact btn-small destructive-action" type="button" pConfirmPopup [disabled]="removingAttachmentId === att.AttachmentID" (click)="confirmRemoveAttachment($event, att)">
                      <i class="pi" [ngClass]="removingAttachmentId === att.AttachmentID ? 'pi-spin pi-spinner' : 'pi-trash'"></i>
                      <span class="ml-1">Remove</span>
                    </button>
                  </div>
                }
              </div>
            }
            @if (!question.QuestionAttachments || question.QuestionAttachments.length === 0) {
              <p class="text-sm text-grey-700 mt-2">No attachments.</p>
            }
            <div class="mt-3">
              <label class="btn-inverse btn-compact btn-small cursor-pointer">
                <i class="pi" [ngClass]="addingAttachment ? 'pi-spin pi-spinner' : 'pi-upload'"></i>
                <span class="ml-1">Add Attachment</span>
                <input type="file" class="hidden" (change)="onAttachmentSelected($event)" />
              </label>
            </div>
          </div>
        }
      </div>

      <div class="mt-4">
        <button type="button" class="accordion-trigger w-full flex items-center justify-between" (click)="togglePhotos()" [ngClass]="{'expanded': photosExpanded}">
          <div class="flex items-center gap-2">
            <i class="pi pi-camera text-grey-700"></i>
            <span class="label mb-0">Photos</span>
          </div>
          <div class="flex items-center gap-2">
            <span class="count-pill">{{question.Photos.length || 0}}</span>
            <i class="pi" [ngClass]="photosExpanded ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
          </div>
        </button>
        @if (photosExpanded) {
          <div class="accordion-body">
            @if (question.Photos!.length > 0) {
              <div class="flex flex-wrap gap-3 mt-2">
                @for (photo of question.Photos; track photo) {
                  <div class="relative">
                    <img [src]="photoSrc(photo)" class="h-28 w-28 object-cover rounded border border-green-50" />
                    <button class="absolute top-1 right-1 btn-inverse btn-compact btn-small destructive-action" type="button" pConfirmPopup [disabled]="removingPhotoGuid === photo" (click)="confirmRemovePhoto($event, photo)">
                      <i class="pi" [ngClass]="removingPhotoGuid === photo ? 'pi-spin pi-spinner' : 'pi-times'"></i>
                    </button>
                  </div>
                }
              </div>
            }
            @if (!question.Photos || question.Photos.length === 0) {
              <p class="text-sm text-grey-700 mt-2">No photos.</p>
            }
            <div class="mt-3">
              <label class="btn-inverse btn-compact btn-small cursor-pointer">
                <i class="pi" [ngClass]="addingPhoto ? 'pi-spin pi-spinner' : 'pi-camera'"></i>
                <span class="ml-1">Add Photo</span>
                <input type="file" accept="image/*" class="hidden" (change)="onPhotoSelected($event)" />
              </label>
            </div>
          </div>
        }
      </div>
      <div class="mt-5 section-block" [ngClass]="{'editing-active': isEditing('actions')}">
        <div class="flex items-center justify-between">
          <p class="label">Actions</p>
          <div class="flex gap-2">
            @if (loadingActions) {
              <span class="text-xs text-grey-700 mr-2">Loading...</span>
            }
            @if (!isEditing('actions')) {
              <button type="button" class="btn-inverse btn-compact btn-small" (click)="startEdit('actions')" [disabled]="!canEdit('actions')" [ngClass]="{'disabled-edit': editingSection && !isEditing('actions')}">
                <i class="pi pi-plus mr-1"></i>
                <span>Add New Actions</span>
              </button>
            }
            @if (isEditing('actions')) {
              <button type="button" class="btn-inverse btn-compact btn-small" (click)="cancelEdit('actions')">
                <i class="pi pi-check mr-1"></i>
                <span>Done</span>
              </button>
            }
          </div>
        </div>
        @if (isEditing('actions')) {
          <div class="action-form border border-grey-200 rounded px-3 py-3 bg-white mt-2">
            <label class="font-semibold text-sm block mb-2">Action Description</label>
            <textarea pTextarea class="text-box w-full" rows="3" [(ngModel)]="actionDescription" [ngClass]="{'p-invalid': actionDescriptionError}"></textarea>
            @if (actionDescriptionError) {
              <p class="text-danger-base text-xs mt-1">{{actionDescriptionError}}</p>
            }
            <div class="grid grid-cols-1 md:grid-cols-3 gap-3 mt-3">
              <div>
                <label class="font-semibold text-sm block mb-1">Assigned To</label>
                <p-select
                  class="w-full prime-input"
                  [options]="actionUsers"
                  optionLabel="DisplayName"
                  optionDisabled="Disabled"
                  placeholder="Select a user"
                  [(ngModel)]="actionAssignee"
                  [ngClass]="{'p-invalid': actionOwnerError}">
                  <ng-template let-user pTemplate="item">
                    <span [ngClass]="{'font-bold': user?.UserTypeID === 2}">{{user?.DisplayName}}</span>
                  </ng-template>
                  <ng-template let-user pTemplate="selectedItem">
                    <span [ngClass]="{'font-bold': user?.UserTypeID === 2}">{{user?.DisplayName}}</span>
                  </ng-template>
                </p-select>
                @if (actionOwnerError) {
                  <p class="text-danger-base text-xs mt-1">{{actionOwnerError}}</p>
                }
              </div>
              <div>
                <label class="font-semibold text-sm block mb-1">Due Date</label>
                <p-datepicker class="date-input w-full" [showIcon]="false" dateFormat="dd M yy" [(ngModel)]="actionDeadline" [minDate]="actionMinDate" [ngClass]="{'p-invalid': actionDateError}"></p-datepicker>
                @if (actionDateError) {
                  <p class="text-danger-base text-xs mt-1">{{actionDateError}}</p>
                }
              </div>
              <div class="flex items-end">
                <button class="btn-primary btn-small" type="button" (click)="addStagedAction()" [disabled]="savingActions">
                  <i class="pi" [ngClass]="savingActions ? 'pi-spin pi-spinner' : 'pi-plus'"></i>
                  <span class="ml-1">Add to list</span>
                </button>
              </div>
            </div>
          </div>
          @if (stagedActions.length > 0) {
            <div class="mt-3">
              <p class="font-semibold text-sm mb-2">Actions to create</p>
              <div class="flex flex-col gap-2">
                @for (act of stagedActions; track act; let i = $index) {
                  <div class="action-row border border-grey-200 rounded px-3 py-2 bg-grey-50 flex justify-between items-start">
                    <div>
                      <p class="font-semibold text-grey-900">{{act.ActionNote}}</p>
                      <p class="text-sm text-grey-700">Owner: {{act.ActionOwner.DisplayName || 'Unassigned'}}</p>
                      @if (act.ActionDeadline) {
                        <p class="text-xs text-grey-600">Due {{act.ActionDeadline | date:'dd MMM yyyy'}}</p>
                      }
                    </div>
                    <button class="btn-inverse btn-compact btn-small destructive-action" type="button" (click)="removeStagedAction(i)">
                      <i class="pi pi-times"></i>
                    </button>
                  </div>
                }
              </div>
              <div class="flex justify-end mt-2">
                <button class="btn-primary btn-small" type="button" (click)="saveStagedActions()" [disabled]="savingActions">
                  <i class="pi" [ngClass]="savingActions ? 'pi-spin pi-spinner' : 'pi-check'"></i>
                  <span class="ml-1">{{savingActions ? 'Saving...' : 'Create Actions'}}</span>
                </button>
              </div>
            </div>
          }
        }
        <div class="mt-4">
          <p class="font-semibold text-sm mb-2">Existing Actions</p>
          @if (existingActions.length === 0) {
            <p class="text-sm text-grey-700">No actions for this question.</p>
          }
          @if (existingActions.length > 0) {
            <div class="flex flex-col gap-2">
              @for (act of existingActions; track act.ActionID) {
                <button type="button" class="action-row border border-green-50 rounded px-3 py-2 bg-white flex justify-between items-start text-left w-full" (click)="openExistingAction(act.ActionID)">
                  <div>
                    <p class="font-semibold text-grey-900">{{act.ActionDescription || act.ActionAuthor || 'Action'}}</p>
                    <p class="text-sm text-grey-700">Assigned to {{act.AssignedTo || 'Unassigned'}}</p>
                    @if (act.ActionDeadline) {
                      <p class="text-xs text-grey-600">Due {{act.ActionDeadline | date:'dd MMM yyyy'}}</p>
                    }
                  </div>
                  <span class="text-xs" [ngClass]="act.Resolved ? 'text-green-700' : 'text-danger-base'">{{act.Resolved ? 'Resolved' : 'Open'}}</span>
                </button>
              }
            </div>
          }
        </div>
      </div>
      @if (errorMessage) {
        <p class="text-danger-base text-sm mt-2">{{errorMessage}}</p>
      }
      <!--<div class="flex gap-2 mt-4">
      <button class="btn-inverse btn-small" type="button" (click)="cancel()">Back</button>
    </div>-->
  </div>
</div>
</div>
<p-confirmpopup key="confirmPopup" styleClass="confirm-popup-danger">
  <ng-template pTemplate="headless" let-confirmation>
    <div class="confirm-popup-wrapper flex items-start gap-3">
      <i class="pi pi-exclamation-triangle text-danger-base text-xl"></i>
      <div class="flex flex-col gap-3 w-full">
        <div>
          <p class="font-semibold">{{confirmation?.header}}</p>
          <p class="text-sm">{{confirmation?.message}}</p>
        </div>
        <div class="flex gap-2 justify-end w-full">
          <button type="button" class="btn-inverse btn-compact btn-small confirm-keep-btn" (click)="onConfirmReject(confirmation)">
            <i class="pi pi-undo mr-1"></i>
            <span>Keep</span>
          </button>
          <button type="button" class="btn-negative btn-compact btn-small confirm-remove-btn" (click)="onConfirmAccept(confirmation)">
            <i class="pi pi-trash mr-1"></i>
            <span>Remove</span>
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</p-confirmpopup>
